import { Clock, CheckCircle, Coins, Users } from "lucide-react";

function fmt(n) { return n == null ? "0" : n.toLocaleString("pt-BR"); }

export default function DoletasStatsCards({ stats }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-2">
          <Clock className="w-4 h-4 text-amber-600" />
          <span className="text-xs text-amber-700 font-medium">Pendentes</span>
        </div>
        <p className="text-2xl font-bold text-amber-800" data-testid="stat-pending">{fmt(stats.total_pending)}</p>
      </div>
      <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-2">
          <CheckCircle className="w-4 h-4 text-emerald-600" />
          <span className="text-xs text-emerald-700 font-medium">Aprovadas</span>
        </div>
        <p className="text-2xl font-bold text-emerald-800" data-testid="stat-approved">{fmt(stats.total_approved)}</p>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-2">
          <Coins className="w-4 h-4 text-blue-600" />
          <span className="text-xs text-blue-700 font-medium">Doletas Circulando</span>
        </div>
        <p className="text-2xl font-bold text-blue-800" data-testid="stat-total-doletas">{fmt(stats.total_doletas_circulando)}</p>
      </div>
      <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-2">
          <Users className="w-4 h-4 text-purple-600" />
          <span className="text-xs text-purple-700 font-medium">Participantes</span>
        </div>
        <p className="text-2xl font-bold text-purple-800" data-testid="stat-participants">{fmt(stats.total_participants)}</p>
      </div>
    </div>
  );
}
